/**
 * Brand colours.
 *
 * This is the one file to edit when reusing this application for another site.
 * Each mode takes exactly two colours; everything else in the UI (gradients,
 * accents, focus rings, hover states, the ambient page glow) is derived from
 * them, so the two modes stay consistent without hand-tuning a palette twice.
 *
 * `primary` and `secondary` are the two ends of the brand gradient, in that
 * order. Give light mode its own pair when the dark-mode colours are too dark
 * or too saturated against a near-white background.
 *
 * Examples:
 *   EFSH   dark { primary: '#1A3C8A', secondary: '#329A37' }   blue -> green
 *   Orange dark { primary: '#EA580C', secondary: '#1D4ED8' }   orange -> blue
 */
export type BrandPair = {
    /** First stop of the brand gradient. */
    primary: string;
    /** Second stop of the brand gradient. */
    secondary: string;
};

export type BrandConfig = {
    light: BrandPair;
    dark: BrandPair;
};

export const brandConfig: BrandConfig = {
    dark: {
        primary: '#1A3C8A',
        secondary: '#329A37',
    },
    light: {
        // Slightly deeper than the dark-mode pair so the gradient keeps its
        // weight against a light background.
        primary: '#17357B',
        secondary: '#2A8730',
    },
};
